
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CORE_ROUTES } from '@/core/core.router';
import KEYS from '@/values/keys';
import { SOCKET_EVENTS, EVENT_TYPES } from '@/meetings/values/meetings.values';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import edPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import { _APP_STORE } from '@/core/values/app.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import { RESET_READ_ONLY_EVENT, SEND_READ_ONLY_STATE_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({
  name: 'ed-toggle-meetings'
})
export default class EdToggleMeetings extends Vue {
  
  public toggleMenuID: string = 'EdToggleMeetings';

  public switchToggle = false;

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  }

  get switchToggleTitle() {
    return this.switchToggle ? `${this.$i18n.t('menu.onToggle')}` : `${this.$i18n.t('menu.offToggle')}`;
  }

  public onChangeStudentToggle() {
    let dataSend = { toggle: this.switchToggle };
    let message : WebSocketMessageRequest = edPresentationModeFactory.createWebSocketMessageRequest(EVENT_TYPES.studentToggle, String(this.currentMeetingData.meetingId), false, JSON.stringify(dataSend));
    this.$EdSocket.emit(SOCKET_EVENTS.updateLocation, message);
  }

  private emitMeetingConnected() : void {      
      this.onChangeStudentToggle();
  }

  private validateMeetingsParamsToInit() : void {
      if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
          this.emitMeetingConnected();
      }
  }

  private validateMeetingsStoreValues(){
      this.$store.subscribe((mutation) => {
          if(mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) {
            this.validateMeetingsParamsToInit();
          }
      });
  }

  private sendReadOnlyState() : void {
    if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
        this.emitMeetingConnected();
    }else {
        this.validateMeetingsStoreValues();
    }
  }

  private resetReadOnly() : void {
    this.switchToggle = false;
  }

  mounted() {
    this.sendReadOnlyState();
    this.$edEventBus.$on(SEND_READ_ONLY_STATE_EVENT, this.sendReadOnlyState);
    this.$edEventBus.$on(RESET_READ_ONLY_EVENT, this.resetReadOnly);

  }

  beforeDestroy() {
    this.$edEventBus.$off(SEND_READ_ONLY_STATE_EVENT, this.sendReadOnlyState);
    this.$edEventBus.$off(RESET_READ_ONLY_EVENT, this.resetReadOnly);
  }
}